import { fetchResearchCoverage } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const ResearchCoverageKeys = {
    all: ['researchcoverage'] as const,
    lists: () => [...ResearchCoverageKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...ResearchCoverageKeys.lists(), page, perPage, filters] as const,
    details: () => [...ResearchCoverageKeys.all, 'detail'] as const,
    detail: (params: number) => [...ResearchCoverageKeys.details(), params] as const,
}

export const useResearchCoverageQuery = (SK_PESQUISA: number) => {
    return useQuery({
        queryFn: () => fetchResearchCoverage(SK_PESQUISA),
        queryKey: ResearchCoverageKeys.detail(SK_PESQUISA),
    })
}
